const TAB_ID_KEY = 'simpallo_tab_id';
const TAB_INSTANCE_KEY = 'simpallo_tab_instance';
const INSTANCE_TOKEN_GLOBAL_KEY = '__simpalloTabInstanceToken';

type GlobalWithInstanceToken = typeof globalThis & {
  [INSTANCE_TOKEN_GLOBAL_KEY]?: string;
};

// Pin the instance token to globalThis so Vite HMR re-evaluating this
// module does not regenerate it. A new token would make getTabId() think
// the tab was duplicated and mint a fresh tabId, locking the user out of
// their own edit lock (DB still references the old tabId).
function getInstanceToken(): string {
  const g = globalThis as GlobalWithInstanceToken;
  if (!g[INSTANCE_TOKEN_GLOBAL_KEY]) {
    g[INSTANCE_TOKEN_GLOBAL_KEY] = crypto.randomUUID();
  }
  return g[INSTANCE_TOKEN_GLOBAL_KEY]!;
}

let cachedTabId: string | null = null;

export function getTabId(): string {
  if (cachedTabId) return cachedTabId;

  const instanceToken = getInstanceToken();
  const storedTabId = sessionStorage.getItem(TAB_ID_KEY);
  const storedInstance = sessionStorage.getItem(TAB_INSTANCE_KEY);

  // If we have a stored tabId but a DIFFERENT instance token,
  // we inherited sessionStorage from another tab (duplicate tab scenario)
  if (storedTabId && storedInstance && storedInstance !== instanceToken) {
    // This is a duplicated tab - generate fresh ID
    cachedTabId = crypto.randomUUID();
  } else {
    // Either fresh tab or same instance (SPA navigation) - use existing or generate
    cachedTabId = storedTabId || crypto.randomUUID();
  }

  sessionStorage.setItem(TAB_ID_KEY, cachedTabId);
  sessionStorage.setItem(TAB_INSTANCE_KEY, instanceToken);
  return cachedTabId;
}
